import React from "react";
import { Row, Col, Table } from "antd";
import TaskManagementFilters from "../../pages/workspace/task-management/task-collection/CollectionEnumerators/TaskManagementFilters";

import "./TableData.scss";

const TableData = React.memo(
   ({
      dataSource,
      updatedColumns,
      loadData,
      handleSearch,
      pagination,
      handlePagination = () => {},
      filterValue,
      onSelect,
      handleClearFilters
   }) => {
      return (
         <div className="table-data tasksManagementPage">
            <TaskManagementFilters
               enumeratorsPage
               onSelectChange={onSelect}
               filterValue={filterValue}
               handleSearch={handleSearch}
               handleClearFilters={handleClearFilters}
            />
            <Row justify="space-between" gutter={[8, 16]}>
               <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h3>Total size: {pagination.total}</h3>
               </Col>
            </Row>
            <>
               {/* {mobile ? (
                  <>
                     <MobileData
                        filteredDataSource={dataSource}
                        onComplete={onComplete}
                        onReject={onReject}
                        goToSurvey={goToSurvey}
                     ></MobileData>
                     <Pagination
                        pagination={pagination}
                        handlePagination={handlePagination}
                     ></Pagination>
                  </>
               ) : ( */}
               <Table
                  prefixCls="table-section"
                  dataSource={dataSource}
                  columns={updatedColumns}
                  scroll={dataSource?.length ? { x: 1200, y: 600 } : { x: "auto" }}
                  pagination={
                     pagination
                        ? {
                             ...pagination,
                             position: ["bottomRight"],
                             showSizeChanger: false,
                             onChange: (page, pageSize) => {
                                handlePagination(page, pageSize);
                             }
                          }
                        : false
                  }
                  loading={loadData}
               />
               {/* )} */}
            </>
         </div>
      );
   }
);

export default TableData;
